import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-security-icon',
    templateUrl: './security-icon.component.html',
    styleUrls: ['./security-icon.component.scss']
})
export class SecurityIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 44;
        this.width = 36;
    }
}
